interface NavLink {
  label: string
  href: string
}

const links: any[] = []

export { links, type NavLink }
